import BaseEnum from './BaseEnum';

class LapsedBranches extends BaseEnum {
  fieldsMap = {
    'Accounts_Email': 'Accounts Email',
    'Address1': 'Address 1',
    'Address2': 'Address 2',
    'Address3': 'Address 3',
    'Branch': 'Branch',
    'Branch_Name': 'Branch Name',
    'Branch_Telephone': 'Branch Telephone',
    'Brand': 'Brand',
    'County': 'County',
    'Customer': 'Customer',
    'Decision_Marker_Email': 'Decision Maker Email',
    'Decision_Marker_Name': 'Decision Maker Name',
    'General_Email': 'General Email',
    'Head_Office': 'Head Office',
    'Postcode': 'Postcode',
    'Sales_Contact_Email': 'Sales Contact Email',
    'Sales_Contact_Name': 'Sales Contact Name',
    'Territory': 'Territory',
    'Town': 'Town',
  }
}

export default LapsedBranches.make();